import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { LOG_LEVEL } from '../models/general';

@Injectable({ providedIn: 'root' })
export class ConsoleOverrideService {
  constructor(private logger: LoggerService) {
    this.init();
  }

  private init() {
    const originalLog = console.log;
    const originalError = console.error;
    const originalWarn = console.warn;

    console.log = (...args: any[]) => {
      this.logger.log(args.join(' '), LOG_LEVEL.INFO);
      originalLog.apply(console, args);
    };

    console.error = (...args: any[]) => {
      this.logger.log(args.join(' '), LOG_LEVEL.ERROR);
      originalError.apply(console, args);
    };

    console.warn = (...args: any[]) => {
      this.logger.log(args.join(' '), LOG_LEVEL.WARN);
      originalWarn.apply(console, args);
    };
  }
}
